export const AUTHORIZATION = {
    REDIRECT_URI: window.location.origin,
    AUDIENCE: 'https://app.theezy.com',
    SCOPE: 'openid profile email'
};

export const API = {
    CLIENT_ID: 'JnuKRdZ3ivG8RFyTRJljvDzBjTvXD6j1',
    DOMAIN: 'auth.theezy.com',
    PREFIX: '@@auth0spajs@@'
};
